import { Link } from 'react-router-dom';
import { Badge } from '@/components/ui/badge';
import { recentCatalogs } from '@/lib/dashboardCompute';
import type { Catalog } from '@/types/catalog';

export interface RecentCatalogsPanelProps {
  catalogs: Catalog[];
  deployedCounts: Record<number, number>;
}

/** Most recently created catalogs with deployed-app counts. Wrap in a Panel on the page. */
export function RecentCatalogsPanel({ catalogs, deployedCounts }: RecentCatalogsPanelProps) {
  const recent = recentCatalogs(catalogs, 8);
  if (recent.length === 0) return <p className="text-sm text-muted-foreground">No catalogs yet.</p>;

  return (
    <ul className="divide-y">
      {recent.map((cat) => (
        <li key={cat.id}>
          <Link
            to={`/catalog/${cat.id}`}
            className="flex items-center justify-between gap-3 rounded-sm py-2 outline-none hover:bg-muted/50 focus-visible:ring-2 focus-visible:ring-ring"
          >
            <span title={cat.name} className="min-w-0 truncate font-medium">{cat.name}</span>
            <Badge variant="secondary" className="shrink-0">{deployedCounts[cat.id] ?? 0} deployed</Badge>
          </Link>
        </li>
      ))}
    </ul>
  );
}
